@if (product$ | async; as product) {
  <ng-template
    [cxOutlet]="outlets.SUMMARY"
    [cxOutletContext]="{ product: product }"
    >
    <p [innerHTML]="product?.summary" class="product-summary__content"></p>
  </ng-template>
}
